import { useQuery } from '@hooks/reactQuery';

import { auth } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getMeasurementNamesOokla } from '@api/ookla';

import { TSelectOption } from '@interfaces/components/componentTypes';
import { IMeasurementNamesOoklaDTO } from '@interfaces/platform/dto/ooklaDTO';

import { refetchOptions } from '@constants/common';
import { MEASUREMENT_NAMES_OOKLA } from '@constants/queryKeys';

interface IUseQueryMeasurementNamesOoklaReturn {
	isLoadingMeasurementNamesOokla: boolean;
	measurementNamesOokla: Array<TSelectOption>;
}

export const useQueryMeasurementNamesOokla = (): IUseQueryMeasurementNamesOoklaReturn => {
	const {
		accessPermission: {
			assetConsumerOrganizationAdministrator,
			networkOperatorOrganizationAdministrator,
			assetOwnerOrganizationAdministrator,
		},
	} = useAppSelector(auth);

	const isAllowed = (
		assetConsumerOrganizationAdministrator ||
		networkOperatorOrganizationAdministrator ||
		assetOwnerOrganizationAdministrator
	);

	const {
		data: measurementNamesOokla,
		isLoading: isLoadingMeasurementNamesOokla,
		isFetching: isFetchingMeasurementNamesOokla,
	} = useQuery({
			queryKey: [MEASUREMENT_NAMES_OOKLA],
			queryFn: getMeasurementNamesOokla,
			select: (measurementName: IMeasurementNamesOoklaDTO[]) => {
				return measurementName?.map(item => {
					return {
						...item,
						value: item.id,
						name: item.name,
						label: item.name,
					};
				});
			},
			enabled: [isAllowed],
			...refetchOptions,
		},
	);

	return {
		isLoadingMeasurementNamesOokla: isLoadingMeasurementNamesOokla || isFetchingMeasurementNamesOokla,
		measurementNamesOokla: measurementNamesOokla || [],
	};
};
